<template>
    <div class="pa-5 pb-0">
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Shop name" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeShop.name ? activeShop.name : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Type" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeShop.type ? activeShop.type : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Comment" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeShop.comment ? activeShop.comment : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Address" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeShop.address ? activeShop.address : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "City" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeShop.address_place ? activeShop.address_place : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Parish" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeShop.address_parish ? activeShop.address_parish : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "County" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeShop.address_county ? activeShop.address_county : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Country" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ countryName ? countryName : activeShop.address_country }}
            </v-col>
        </v-row>
        <v-divider class="my-2" />

        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Latitude" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeShop.latitude ? activeShop.latitude : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Longitude" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeShop.longitude ? activeShop.longitude : "-" }}
            </v-col>
        </v-row>
        <v-divider class="my-2" />
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Eugesta code" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeShop.eugesta_code ? activeShop.eugesta_code : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Smarten code" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeShop.smarten_code ? activeShop.smarten_code : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Other code" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeShop.other_code ? activeShop.other_code : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Additional info" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeShop.additional_field ? activeShop.additional_field : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-img
                v-if="activeShop.image_path"
                :src="activeShop.image_path"
                max-width="350"
                contain
                class="grey lighten-2 mt-3"
            />
        </v-row>
    </div>
</template>

<script>
import { mapState } from "vuex";
import Store from "@/store";

export default {
    name: "general-info-tab",

    data() {
        return {
            countryName: null
        };
    },
    computed: {
        ...mapState("ShopsAdminStore", ["activeShop"]),
        ...mapState(["countries"])
    },
    watch: {
        activeShop: async function() {
            if (this.activeShop.address_country) {
                this.countryName = await this.countries.find(x => x.code === this.activeShop.address_country);
                if (this.countryName) {
                    if (this.countryName.name_et) {
                        this.countryName = this.countryName.name_et;
                    } else {
                        this.countryName = this.countryName.name_en;
                    }
                }
            }
        }
    },
    async mounted() {
        if (this.countries.length === 0) {
            await Store.dispatch("fetchCountries");
        }
    },
    methods: {}
};
</script>

<style scoped>
.row-title {
    color: gray;
}

.col-item {
    padding-top: 8px;
    padding-bottom: 8px;
}

.dot {
    margin-right: 10px;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    display: inline-block;
}
</style>
